module.exports = __webpack_public_path__ + "static/media/VarunRamnani.667223b7.jpeg";